var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"newspaper_content"},[(_vm.loaded && _vm.isShowPc)?_c('newspaperOfPc'):_vm._e(),(_vm.loaded && !_vm.isShowPc)?_c('newspaperOfMobile'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }